import React from 'react';
import styles from './ThumbnailStrip.module.css';

export default function ThumbnailStrip({ images, activeIndex, onSelect }) {
  if (!images?.length) return null;
  return (
    <div className={styles.strip}>
      {images.map((img, i) => (
        <button
          key={img.name}
          className={`${styles.thumb} ${i === activeIndex ? styles.active : ''}`}
          onClick={() => onSelect?.(i)}
          title={img.name}
        >
          <span className={styles.idx}>{i + 1}</span>
        </button>
      ))}
    </div>
  );
}
